import { InsightDetailFiltersValue } from './insight-detail-filters.context';

/**
 * Build ExportModal `data` from the insight's effective filters (resolved defaults included).
 * Omits bin_size (chart-only). Entity-only insights get no date period.
 */
export const buildInsightExportData = (filters: InsightDetailFiltersValue): Record<string, unknown> => {
    const data: Record<string, unknown> = { ...filters.entityParams };

    if (filters.showDateRange && filters.after && filters.before) {
        data.after = filters.after;
        data.before = filters.before;
    }

    return data;
};
